import ExtendableError from 'es6-error';

export class QuotaExceededError extends ExtendableError {
  constructor(message = 'Rate limit exceeded.') {
    super(message);
    this.name = 'Quota';
    this.code = 130;
    this.retry = false;
  }
}

export class DataServiceError extends ExtendableError {
  constructor(message = 'The service is temporarily unavailable.') {
    super(message);
    this.name = 'Data Service';
    this.code = 100;
    this.retry = true;
  }
}

export class ConfigurationMissingError extends ExtendableError {
  constructor(message = 'Configuration not found.') {
    super(message);
    this.name = 'Configuration';
    this.code = 110;
    this.retry = false;
  }
}

export class ConfigurationServiceError extends ExtendableError {
  constructor(message = 'The service is temporarily unavailable.') {
    super(message);
    this.name = 'Configuration Service';
    this.code = 120;
    this.retry = true;
  }
}

export class FontServiceError extends ExtendableError {
  constructor(message = 'The service is temporarily unavailable.') {
    super(message);
    this.name = 'Font Service';
    this.code = 130;
    this.retry = true;
  }
}

export class DisabledAppError extends ExtendableError {
  constructor(message = 'The App has been disabled.') {
    super(message);
    this.name = 'App Disabled';
    this.code = 140;
    this.retry = false;
  }
}
